/* src/app/builder-screen-beta/inspector/number-format-modal.component.scss */
.number-format-modal .modal-header {
  margin-bottom: 16px;
}
.number-format-modal .modal-header h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #262626;
}
.number-format-modal .modal-header .help-text {
  margin: 0;
  font-size: 13px;
  color: #8c8c8c;
  line-height: 1.5;
}
.number-format-modal .modal-content .preview-section {
  background:
    linear-gradient(
      135deg,
      #f6ffed 0%,
      #e6f7ff 100%);
  border: 1px solid #b7eb8f;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  margin-bottom: 8px;
}
.number-format-modal .modal-content .preview-section .preview-label {
  font-size: 12px;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}
.number-format-modal .modal-content .preview-section .preview-value {
  font-size: 28px;
  font-weight: 600;
  color: #52c41a;
  font-family: "Courier New", monospace;
  word-break: break-all;
}
.number-format-modal .modal-content .preview-section .preview-input-label {
  font-size: 11px;
  color: #8c8c8c;
  margin-top: 8px;
}
.number-format-modal .modal-content .format-settings .setting-row {
  margin-bottom: 12px;
}
.number-format-modal .modal-content .format-settings .setting-row nz-form-item {
  margin-bottom: 0;
}
.number-format-modal .modal-content .format-settings .separators-row,
.number-format-modal .modal-content .format-settings .addon-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 12px;
}
.number-format-modal .modal-content .format-settings .separators-row .setting-item nz-form-item,
.number-format-modal .modal-content .format-settings .addon-row .setting-item nz-form-item {
  margin-bottom: 0;
}
.number-format-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
@media (max-width: 480px) {
  .number-format-modal .modal-content .separators-row,
  .number-format-modal .modal-content .addon-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .number-format-modal .modal-content .preview-section .preview-value {
    font-size: 22px;
  }
}
/*# sourceMappingURL=number-format-modal.component.css.map */
